"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateQueryInfo = exports.calculateDataRequirements = exports.calculateGapsInCare = exports.calculateRaw = exports.calculateAggregateMeasureReport = exports.calculateIndividualMeasureReports = exports.calculateMeasureReports = exports.calculate = void 0;
var Enums_1 = require("../types/Enums");
var Execution = __importStar(require("../execution/Execution"));
var CalculatorHelpers = __importStar(require("./DetailedResultsBuilder"));
var MeasureBundleHelpers = __importStar(require("../helpers/MeasureBundleHelpers"));
var ResultsHelpers = __importStar(require("./ClauseResultsBuilder"));
var MeasureReportBuilder_1 = __importDefault(require("./MeasureReportBuilder"));
var GapsInCareHelpers = __importStar(require("../gaps/GapsReportBuilder"));
var HTMLBuilder_1 = require("./HTMLBuilder");
var QueryFilterParser_1 = require("../gaps/QueryFilterParser");
var RetrievesHelper = __importStar(require("../gaps/RetrievesFinder"));
var lodash_1 = require("lodash");
var DataRequirementHelpers_1 = require("../helpers/DataRequirementHelpers");
var CustomErrors_1 = require("../types/errors/CustomErrors");
var cql_execution_1 = require("cql-execution");
var cql_exec_fhir_1 = require("cql-exec-fhir");
var DetailedResultsHelpers_1 = require("../helpers/DetailedResultsHelpers");
/**
 * Calculate measure against a set of patients. Returning detailed results for each patient and population group.
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns Detailed execution results. One for each patient.
 */
function calculate(measureBundle, patientBundles, options, valueSetCache) {
    var _a, _b, _c, _d, _e, _f;
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        var debugObject, patientSource, measurementPeriod, measure, executionResults, results, rawResults, elmLibraries, mainLibraryName, patientIds, prunedExecutionResults;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    // Ensure verboseCalculationResults defaults to true when not provided in options
                    options.verboseCalculationResults = (_a = options.verboseCalculationResults) !== null && _a !== void 0 ? _a : true;
                    debugObject = options.enableDebugOutput ? {} : undefined;
                    patientSource = resolvePatientSource(patientBundles, options);
                    // Ensure the CalculationOptions have sane defaults, only if they're not set
                    options.calculateHTML = (_b = options.calculateHTML) !== null && _b !== void 0 ? _b : true;
                    options.calculateSDEs = (_c = options.calculateSDEs) !== null && _c !== void 0 ? _c : true;
                    measurementPeriod = MeasureBundleHelpers.extractMeasurementPeriod(measureBundle);
                    // Set the measurement period start/end, but only if the caller didn't specify one
                    options.measurementPeriodStart = (_d = options.measurementPeriodStart) !== null && _d !== void 0 ? _d : measurementPeriod.measurementPeriodStart;
                    options.measurementPeriodEnd = (_e = options.measurementPeriodEnd) !== null && _e !== void 0 ? _e : measurementPeriod.measurementPeriodEnd;
                    measure = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
                    executionResults = [];
                    return [4 /*yield*/, Execution.execute(measureBundle, patientSource, options, valueSetCache, debugObject)];
                case 1:
                    results = _g.sent();
                    if (!results.rawResults) {
                        throw new Error((_f = results.errorMessage) !== null && _f !== void 0 ? _f : 'something happened with no error message');
                    }
                    rawResults = results.rawResults;
                    if (!results.elmLibraries || !results.mainLibraryName) {
                        throw new CustomErrors_1.UnexpectedResource('no libraries were found');
                    }
                    elmLibraries = results.elmLibraries;
                    mainLibraryName = results.mainLibraryName;
                    patientIds = Object.keys(rawResults.patientResults);
                    // Iterate over patient bundles and make results for each of them.
                    patientIds.forEach(function (patientId) {
                        var _a;
                        var patientExecutionResult = {
                            patientId: patientId,
                            detailedResults: [],
                            evaluatedResource: rawResults.patientEvaluatedRecords[patientId],
                            patientObject: rawResults.patientResults[patientId]['Patient']
                        };
                        // Grab statement results for the patient
                        var patientStatementResults = rawResults.patientResults[patientId];
                        // Grab localId results for the patient
                        var patientLocalIdResults = rawResults.localIdPatientResultsMap[patientId];
                        // iterator to use for group ID if they are defined in the population groups
                        var i = 1;
                        // Iterate over measure population groups
                        (_a = measure.group) === null || _a === void 0 ? void 0 : _a.forEach(function (group) {
                            var _a, _b, _c, _d;
                            // build initial results set with population values
                            var detailedGroupResult = CalculatorHelpers.createPopulationValues(measure, group, patientStatementResults);
                            // fix groupId to an auto incremented if it was not found.
                            if (detailedGroupResult.groupId === 'unknown') {
                                detailedGroupResult.groupId = "population-group-" + i++;
                            }
                            // get the relevance information for each population
                            detailedGroupResult.populationRelevance = ResultsHelpers.buildPopulationGroupRelevanceMap(group, detailedGroupResult);
                            // use relevance info to fill out statement relevance information and create initial statementResults structure
                            detailedGroupResult.statementResults = ResultsHelpers.buildStatementRelevanceMap(measure, detailedGroupResult.populationRelevance, mainLibraryName, elmLibraries, group, (_a = options.calculateSDEs) !== null && _a !== void 0 ? _a : false);
                            // adds result information to the statement results and builds up clause results
                            detailedGroupResult.clauseResults = ResultsHelpers.buildStatementAndClauseResults(measure, elmLibraries, patientLocalIdResults, detailedGroupResult.statementResults, true, true);
                            if (options.calculateHTML) {
                                var html = HTMLBuilder_1.generateHTML(elmLibraries, detailedGroupResult.statementResults, detailedGroupResult.clauseResults, detailedGroupResult.groupId);
                                detailedGroupResult.html = html;
                                if (debugObject && options.enableDebugOutput) {
                                    var debugHtml = {
                                        name: "clauses-" + detailedGroupResult.groupId + ".html",
                                        html: html
                                    };
                                    if (Array.isArray(debugObject.html) && ((_b = debugObject.html) === null || _b === void 0 ? void 0 : _b.length) !== 0) {
                                        (_c = debugObject.html) === null || _c === void 0 ? void 0 : _c.push(debugHtml);
                                    }
                                    else {
                                        debugObject.html = [debugHtml];
                                    }
                                }
                            }
                            // add this group result to the patient results
                            (_d = patientExecutionResult.detailedResults) === null || _d === void 0 ? void 0 : _d.push(detailedGroupResult);
                        });
                        // put raw SDE values onto execution result
                        if (options.calculateSDEs) {
                            patientExecutionResult.supplementalData = ResultsHelpers.getSDEValues(measure, patientStatementResults);
                        }
                        executionResults.push(patientExecutionResult);
                    });
                    if (debugObject && options.enableDebugOutput) {
                        debugObject.detailedResults = executionResults;
                    }
                    if (options.verboseCalculationResults === false) {
                        // Prune to simple view
                        prunedExecutionResults = DetailedResultsHelpers_1.pruneDetailedResults(executionResults);
                    }
                    else {
                        prunedExecutionResults = executionResults;
                    }
                    // return with the ELM libraries and main library name for further processing if requested.
                    if (options.returnELM) {
                        return [2 /*return*/, __assign({ results: prunedExecutionResults, debugOutput: debugObject, elmLibraries: results.elmLibraries, mainLibraryName: results.mainLibraryName, parameters: results.parameters }, (options.useValueSetCaching && results.valueSetCache && { valueSetCache: results.valueSetCache }))];
                    }
                    else {
                        return [2 /*return*/, __assign({ results: prunedExecutionResults, debugOutput: debugObject }, (options.useValueSetCaching && results.valueSetCache && { valueSetCache: results.valueSetCache }))];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.calculate = calculate;
/**
 * Calculate measure against a set of patients. Returning individual or summary MeasureReports based on options
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns MeasureReport resource(s) for each patient or entire population according to standard https://www.hl7.org/fhir/measurereport.html
 */
function calculateMeasureReports(measureBundle, patientBundles, options, valueSetCache) {
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, options.reportType === 'summary'
                    ? calculateAggregateMeasureReport(measureBundle, patientBundles, options, valueSetCache)
                    : calculateIndividualMeasureReports(measureBundle, patientBundles, options, valueSetCache)];
        });
    });
}
exports.calculateMeasureReports = calculateMeasureReports;
/**
 * Calculate measure against a set of patients. Returning measure reports for each patient.
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns MeasureReport resource for each patient according to standard https://www.hl7.org/fhir/measurereport.html
 */
function calculateIndividualMeasureReports(measureBundle, patientBundles, options, valueSetCache) {
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        var calculationResults, results, debugOutput, reports;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (options.reportType && options.reportType !== 'individual') {
                        throw new CustomErrors_1.UnsupportedProperty('calculateMeasureReports only supports reportType "individual".');
                    }
                    return [4 /*yield*/, calculate(measureBundle, patientBundles, options, valueSetCache)];
                case 1:
                    calculationResults = _a.sent();
                    results = calculationResults.results, debugOutput = calculationResults.debugOutput;
                    reports = MeasureReportBuilder_1.default.buildMeasureReports(measureBundle, results, options);
                    if (debugOutput && options.enableDebugOutput) {
                        debugOutput.measureReports = reports;
                    }
                    return [2 /*return*/, { results: reports, debugOutput: debugOutput, valueSetCache: calculationResults.valueSetCache }];
            }
        });
    });
}
exports.calculateIndividualMeasureReports = calculateIndividualMeasureReports;
/**
 * Calculate measure against a set of patients. Returning a single MeasureReport for aggregated results.
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns MeasureReport resource summary according to standard https://www.hl7.org/fhir/measurereport.html
 */
function calculateAggregateMeasureReport(measureBundle, patientBundles, options, valueSetCache) {
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        var calculationResults, results, debugOutput, builder, report;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (options.reportType && options.reportType === 'individual') {
                        throw new Error('calculateAggregateMeasureReports only supports reportType "summary".');
                    }
                    return [4 /*yield*/, calculate(measureBundle, patientBundles, options, valueSetCache)];
                case 1:
                    calculationResults = _a.sent();
                    results = calculationResults.results, debugOutput = calculationResults.debugOutput;
                    builder = new MeasureReportBuilder_1.default(measureBundle, options);
                    results.forEach(function (result) {
                        builder.addPatientResults(result);
                    });
                    report = builder.getReport();
                    if (debugOutput && options.enableDebugOutput) {
                        debugOutput.measureReports = [report];
                    }
                    return [2 /*return*/, { results: report, debugOutput: debugOutput, valueSetCache: calculationResults.valueSetCache }];
            }
        });
    });
}
exports.calculateAggregateMeasureReport = calculateAggregateMeasureReport;
/**
 * Get raw results from cql-execution
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns pass through of raw calculation results from the engine
 */
function calculateRaw(measureBundle, patientBundles, options, valueSetCache) {
    var _a;
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        var debugObject, patientSource, results;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    debugObject = options.enableDebugOutput ? {} : undefined;
                    patientSource = resolvePatientSource(patientBundles, options);
                    return [4 /*yield*/, Execution.execute(measureBundle, patientSource, options, valueSetCache, debugObject)];
                case 1:
                    results = _b.sent();
                    if (results.rawResults) {
                        return [2 /*return*/, { results: results.rawResults, debugOutput: debugObject, valueSetCache: results.valueSetCache }];
                    }
                    else {
                        throw new CustomErrors_1.ErrorWithDebugInfo((_a = results.errorMessage) !== null && _a !== void 0 ? _a : 'something happened with no error message', debugObject);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.calculateRaw = calculateRaw;
/**
 * Get any gaps in care for the patients
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param patientBundles List of bundles of patients to be executed.
 * @param options Options for calculation.
 * @param valueSetCache Cache of existing valuesets
 * @returns gaps bundle of DetectedIssues and GuidanceResponses
 */
function calculateGapsInCare(measureBundle, patientBundles, options, valueSetCache) {
    if (valueSetCache === void 0) { valueSetCache = []; }
    return __awaiter(this, void 0, void 0, function () {
        var calculationResults, results, debugOutput, elmLibraries, mainLibraryName, parameters, measureReports, result, errorLog, resultPromises;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Detailed results for populations get ELM content back
                    options.returnELM = true;
                    return [4 /*yield*/, calculate(measureBundle, patientBundles, options, valueSetCache)];
                case 1:
                    calculationResults = _a.sent();
                    results = calculationResults.results, debugOutput = calculationResults.debugOutput, elmLibraries = calculationResults.elmLibraries, mainLibraryName = calculationResults.mainLibraryName, parameters = calculationResults.parameters;
                    measureReports = MeasureReportBuilder_1.default.buildMeasureReports(measureBundle, results, options);
                    result = [];
                    errorLog = [];
                    resultPromises = results.map(function (res) { return __awaiter(_this, void 0, void 0, function () {
                        var matchingMeasureReport, drPromises;
                        var _this = this;
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    matchingMeasureReport = measureReports.find(function (mr) { var _a, _b; return ((_b = (_a = mr.subject) === null || _a === void 0 ? void 0 : _a.reference) === null || _b === void 0 ? void 0 : _b.split('/')[1]) === res.patientId; });
                                    if (!matchingMeasureReport) {
                                        throw new Error("No MeasureReport generated during gaps in care for " + res.patientId);
                                    }
                                    drPromises = (_a = res.detailedResults) === null || _a === void 0 ? void 0 : _a.map(function (dr, i) { return __awaiter(_this, void 0, void 0, function () {
                                        var measureResource, scoringCode, denomResult, numerResult, numerRelevance, improvementNotation, populationCriteria, matchingGroup, numerCriteria, numerExpressionName_1, mainLibraryELM, numerELMExpression, retrievesOutput, baseRetrieves, retrievesErrors, gapsRetrieves, grPromises, _a, detailedGapsRetrieves, reasonDetailErrors, _b, detectedIssues, detectedIssueErrors, patient, gapsBundle;
                                        var _this = this;
                                        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
                                        return __generator(this, function (_s) {
                                            switch (_s.label) {
                                                case 0:
                                                    measureResource = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
                                                    scoringCode = (_e = (_d = (_c = measureResource.scoring) === null || _c === void 0 ? void 0 : _c.coding) === null || _d === void 0 ? void 0 : _d.find(function (c) {
                                                        return c.system === 'http://hl7.org/fhir/measure-scoring' ||
                                                            c.system === 'http://terminology.hl7.org/CodeSystem/measure-scoring';
                                                    })) === null || _e === void 0 ? void 0 : _e.code;
                                                    if (scoringCode !== Enums_1.MeasureScoreType.PROP) {
                                                        throw new CustomErrors_1.UnsupportedProperty("Gaps in care not supported for measure scoring type " + scoringCode);
                                                    }
                                                    denomResult = (_g = (_f = dr.populationResults) === null || _f === void 0 ? void 0 : _f.find(function (pr) { return pr.populationType === Enums_1.PopulationType.DENOM; })) === null || _g === void 0 ? void 0 : _g.result;
                                                    numerResult = (_j = (_h = dr.populationResults) === null || _h === void 0 ? void 0 : _h.find(function (pr) { return pr.populationType === Enums_1.PopulationType.NUMER; })) === null || _j === void 0 ? void 0 : _j.result;
                                                    numerRelevance = (_l = (_k = dr.populationRelevance) === null || _k === void 0 ? void 0 : _k.find(function (pr) { return pr.populationType === Enums_1.PopulationType.NUMER; })) === null || _l === void 0 ? void 0 : _l.result;
                                                    if (!((_m = measureResource.improvementNotation) === null || _m === void 0 ? void 0 : _m.coding)) {
                                                        throw new CustomErrors_1.UnexpectedProperty('Measure resource must include improvement notation');
                                                    }
                                                    improvementNotation = measureResource.improvementNotation.coding[0].code;
                                                    if (!improvementNotation) {
                                                        throw new CustomErrors_1.UnexpectedProperty('Improvement notation code not present on measure');
                                                    }
                                                    populationCriteria = numerRelevance &&
                                                        (improvementNotation === Enums_1.ImprovementNotation.POSITIVE ? denomResult && !numerResult : numerResult);
                                                    if (!populationCriteria) return [3 /*break*/, 2];
                                                    matchingGroup = ((_o = measureResource.group) === null || _o === void 0 ? void 0 : _o.find(function (g) { return g.id === dr.groupId; })) || ((_p = measureResource.group) === null || _p === void 0 ? void 0 : _p[i]);
                                                    if (!matchingGroup) {
                                                        throw new Error("Could not find group with id " + dr.groupId + " in measure resource");
                                                    }
                                                    numerCriteria = (_q = matchingGroup.population) === null || _q === void 0 ? void 0 : _q.find(function (pop) { var _a; return ((_a = pop.code) === null || _a === void 0 ? void 0 : _a.coding) && pop.code.coding[0].code === Enums_1.PopulationType.NUMER; });
                                                    if (!numerCriteria) {
                                                        throw new CustomErrors_1.UnexpectedProperty("Could not find numerator criteria expression in measure group " + dr.groupId);
                                                    }
                                                    numerExpressionName_1 = numerCriteria.criteria.expression;
                                                    mainLibraryELM = elmLibraries === null || elmLibraries === void 0 ? void 0 : elmLibraries.find(function (lib) { return lib.library.identifier.id === mainLibraryName; });
                                                    if (!mainLibraryELM || !elmLibraries) {
                                                        throw new CustomErrors_1.UnexpectedResource("Could not find ELM for " + mainLibraryName);
                                                    }
                                                    numerELMExpression = mainLibraryELM.library.statements.def.find(function (e) { return e.name === numerExpressionName_1; });
                                                    if (!numerELMExpression) {
                                                        throw new CustomErrors_1.UnexpectedProperty("Expression " + numerExpressionName_1 + " not found in " + mainLibraryName);
                                                    }
                                                    retrievesOutput = RetrievesHelper.findRetrieves(mainLibraryELM, elmLibraries, numerELMExpression.expression);
                                                    baseRetrieves = retrievesOutput.results;
                                                    retrievesErrors = retrievesOutput.withErrors;
                                                    errorLog.push.apply(errorLog, retrievesErrors);
                                                    gapsRetrieves = GapsInCareHelpers.processQueriesForGaps(baseRetrieves, dr);
                                                    grPromises = gapsRetrieves.map(function (retrieve) { return __awaiter(_this, void 0, void 0, function () {
                                                        var library, _a;
                                                        return __generator(this, function (_b) {
                                                            switch (_b.label) {
                                                                case 0:
                                                                    if (!(retrieve.queryLocalId && retrieve.queryLibraryName)) return [3 /*break*/, 2];
                                                                    library = elmLibraries.find(function (lib) { return lib.library.identifier.id === retrieve.queryLibraryName; });
                                                                    if (!library) return [3 /*break*/, 2];
                                                                    _a = retrieve;
                                                                    return [4 /*yield*/, QueryFilterParser_1.parseQueryInfo(library, elmLibraries, retrieve.queryLocalId, retrieve.valueComparisonLocalId, parameters, res.patientObject)];
                                                                case 1:
                                                                    _a.queryInfo = _b.sent();
                                                                    _b.label = 2;
                                                                case 2: return [2 /*return*/];
                                                            }
                                                        });
                                                    }); });
                                                    return [4 /*yield*/, Promise.all(grPromises)];
                                                case 1:
                                                    _s.sent();
                                                    _a = GapsInCareHelpers.calculateReasonDetail(gapsRetrieves, improvementNotation, dr), detailedGapsRetrieves = _a.results, reasonDetailErrors = _a.withErrors;
                                                    errorLog.push.apply(errorLog, reasonDetailErrors);
                                                    _b = GapsInCareHelpers.generateDetectedIssueResources(detailedGapsRetrieves, matchingMeasureReport, improvementNotation), detectedIssues = _b.detectedIssues, detectedIssueErrors = _b.withErrors;
                                                    errorLog.push.apply(errorLog, detectedIssueErrors);
                                                    patient = (_r = res.patientObject) === null || _r === void 0 ? void 0 : _r._json;
                                                    gapsBundle = GapsInCareHelpers.generateGapsInCareBundle(detectedIssues, matchingMeasureReport, patient);
                                                    result.push(gapsBundle);
                                                    if (debugOutput && options.enableDebugOutput) {
                                                        debugOutput.gaps = {
                                                            retrieves: detailedGapsRetrieves,
                                                            bundle: result
                                                        };
                                                    }
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    result.push({});
                                                    _s.label = 3;
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                    if (!drPromises) return [3 /*break*/, 2];
                                    return [4 /*yield*/, Promise.all(drPromises)];
                                case 1:
                                    _b.sent();
                                    _b.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(resultPromises)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, {
                            results: (result.length === 1 ? result[0] : result),
                            debugOutput: debugOutput,
                            valueSetCache: calculationResults.valueSetCache,
                            withErrors: errorLog
                        }];
            }
        });
    });
}
exports.calculateGapsInCare = calculateGapsInCare;
/**
 * Get data requirements for this measure
 *
 * @param measureBundle Bundle with a MeasureResource and all necessary data for execution.
 * @param options Options for calculation.
 *
 * @returns FHIR Library of data requirements
 */
function calculateDataRequirements(measureBundle, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, cqls, rootLibIdentifier, elmJSONs, rootLib, _b, startCql, endCql, parameters, withErrors, allRetrieves, allRetrievesPromises, results;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = MeasureBundleHelpers.extractLibrariesFromBundle(measureBundle), cqls = _a.cqls, rootLibIdentifier = _a.rootLibIdentifier, elmJSONs = _a.elmJSONs;
                    rootLib = elmJSONs.find(function (ej) { return ej.library.identifier == rootLibIdentifier; });
                    _b = Execution.getCQLIntervalEndpoints(options), startCql = _b.startCql, endCql = _b.endCql;
                    // We need a root library to run dataRequirements properly. If we don't have one, error out.
                    if (!(rootLib === null || rootLib === void 0 ? void 0 : rootLib.library)) {
                        throw new CustomErrors_1.UnexpectedResource("root library doesn't contain a library object"); //unexpected resource
                    }
                    parameters = { 'Measurement Period': new cql_execution_1.Interval(startCql, endCql) };
                    withErrors = [];
                    allRetrieves = rootLib.library.statements.def.flatMap(function (statement) {
                        if (statement.expression && statement.name != 'Patient') {
                            var retrievesOutput = RetrievesHelper.findRetrieves(rootLib, elmJSONs, statement.expression);
                            withErrors.push.apply(withErrors, retrievesOutput.withErrors);
                            return retrievesOutput.results;
                        }
                        else {
                            return [];
                        }
                    });
                    allRetrievesPromises = allRetrieves.map(function (retrieve) { return __awaiter(_this, void 0, void 0, function () {
                        var library, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(retrieve.queryLocalId && retrieve.queryLibraryName)) return [3 /*break*/, 2];
                                    library = elmJSONs.find(function (lib) { return lib.library.identifier.id === retrieve.queryLibraryName; });
                                    if (!library) return [3 /*break*/, 2];
                                    _a = retrieve;
                                    return [4 /*yield*/, QueryFilterParser_1.parseQueryInfo(library, elmJSONs, retrieve.queryLocalId, retrieve.valueComparisonLocalId, parameters)];
                                case 1:
                                    _a.queryInfo = _b.sent();
                                    _b.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(allRetrievesPromises)];
                case 1:
                    _c.sent();
                    results = {
                        resourceType: 'Library',
                        type: { coding: [{ code: 'module-definition', system: 'http://terminology.hl7.org/CodeSystem/library-type' }] },
                        status: 'unknown'
                    };
                    results.dataRequirement = lodash_1.uniqBy(allRetrieves.map(function (retrieve) {
                        var dr = DataRequirementHelpers_1.generateDataRequirement(retrieve);
                        GapsInCareHelpers.addFiltersToDataRequirement(retrieve, dr, withErrors);
                        DataRequirementHelpers_1.addFhirQueryPatternToDataRequirements(dr);
                        return dr;
                    }), JSON.stringify);
                    return [2 /*return*/, {
                            results: results,
                            debugOutput: {
                                cql: cqls,
                                elm: elmJSONs,
                                gaps: {
                                    retrieves: allRetrieves
                                }
                            },
                            withErrors: withErrors
                        }];
            }
        });
    });
}
exports.calculateDataRequirements = calculateDataRequirements;
/**
 * Get detailed query info for all statements of a Measure
 *
 * @param measureBundle Bundle with a Measure resource and all dependent library resources
 * @returns Detailed query info object for all statements
 */
function calculateQueryInfo(measureBundle, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, cqls, rootLibIdentifier, elmJSONs, rootLib, _b, startCql, endCql, parameters, withErrors, allRetrieves, allRetrievesPromises;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = MeasureBundleHelpers.extractLibrariesFromBundle(measureBundle), cqls = _a.cqls, rootLibIdentifier = _a.rootLibIdentifier, elmJSONs = _a.elmJSONs;
                    rootLib = elmJSONs.find(function (ej) { return ej.library.identifier == rootLibIdentifier; });
                    _b = Execution.getCQLIntervalEndpoints(options), startCql = _b.startCql, endCql = _b.endCql;
                    if (!(rootLib === null || rootLib === void 0 ? void 0 : rootLib.library)) {
                        throw new CustomErrors_1.UnexpectedResource("root library doesn't contain a library object"); //unexpected resource
                    }
                    parameters = { 'Measurement Period': new cql_execution_1.Interval(startCql, endCql) };
                    withErrors = [];
                    allRetrieves = rootLib.library.statements.def.flatMap(function (statement) {
                        if (statement.expression && statement.name != 'Patient') {
                            var retrievesOutput = RetrievesHelper.findRetrieves(rootLib, elmJSONs, statement.expression);
                            withErrors.push.apply(withErrors, retrievesOutput.withErrors);
                            return retrievesOutput.results;
                        }
                        else {
                            return [];
                        }
                    });
                    allRetrievesPromises = allRetrieves.map(function (retrieve) { return __awaiter(_this, void 0, void 0, function () {
                        var library, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!(retrieve.queryLocalId && retrieve.queryLibraryName)) return [3 /*break*/, 2];
                                    library = elmJSONs.find(function (lib) { return lib.library.identifier.id === retrieve.queryLibraryName; });
                                    if (!library) return [3 /*break*/, 2];
                                    _a = retrieve;
                                    return [4 /*yield*/, QueryFilterParser_1.parseQueryInfo(library, elmJSONs, retrieve.queryLocalId, retrieve.valueComparisonLocalId, parameters)];
                                case 1:
                                    _a.queryInfo = _b.sent();
                                    _b.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(allRetrievesPromises)];
                case 1:
                    _c.sent();
                    return [2 /*return*/, {
                            results: allRetrieves,
                            debugOutput: {
                                cql: cqls,
                                elm: elmJSONs
                            },
                            withErrors: withErrors
                        }];
            }
        });
    });
}
exports.calculateQueryInfo = calculateQueryInfo;
/**
 * Resolve the PatientSource to use for calculation. If a PatientSource was provided, use it. Otherwise use
 * cql-exec-fhir to make one from Patient Bundles.
 *
 * @param patientBundles Patient bundle array passed in.
 * @param options Options passed into the calculator.
 * @returns PatientSource to use for calculation.
 */
function resolvePatientSource(patientBundles, options) {
    if (options.patientSource) {
        return options.patientSource;
    }
    else {
        //if there are entries, pb.entry?.length will be > 0 which is truthy. Otherwise falsy
        if (patientBundles.filter(function (pb) { var _a; return (_a = pb.entry) === null || _a === void 0 ? void 0 : _a.length; }).length === 0) {
            throw new CustomErrors_1.UnexpectedResource('No entries found in passed patient bundles');
        }
        var patientSource = cql_exec_fhir_1.PatientSource.FHIRv401(options.trustMetaProfile);
        patientSource.loadBundles(patientBundles);
        return patientSource;
    }
}
//# sourceMappingURL=Calculator.js.map